import { render } from "./ArgonButton.vue?vue&type=template&id=9b399068"
import script from "./ArgonButton.vue?vue&type=script&lang=js"
export * from "./ArgonButton.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__